module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "transparent",
    attrs: {
      "href": _vm.link,
      "target": "_blank"
    }
  }, [_vm._t("default", [_vm._v("Go")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38041d4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/LinkNewTab.vue
// module id = 2505
// module chunks = 1